type EnumLike = Record<string, string>;

const isEnumValue = <T extends EnumLike>(
  enumObj: T,
  value: string,
): value is T[keyof T] => Object.values(enumObj).includes(value);

interface GetCurrentComponentNameOptions<T extends EnumLike> {
  element: Element;
  ComponentEnum: T;
  defaultComponent: T[keyof T];
}

const getCurrentComponentName = <T extends EnumLike>({
  element,
  ComponentEnum,
  defaultComponent,
}: GetCurrentComponentNameOptions<T>): T[keyof T] => {
  const reactComponent = element.getAttribute('data-react-component');
  if (reactComponent && isEnumValue(ComponentEnum, reactComponent)) {
    return reactComponent;
  }
  return defaultComponent;
};

export default getCurrentComponentName;
